export default "__VITE_ASSET__6191907e__"